/* eslint-disable semi */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable no-underscore-dangle */
export default function interval(fn, duration) {
  var _this = this
  _this.baseline = undefined

  _this.run = function () {
    if (_this.baseline === undefined) {
      _this.baseline = new Date().getTime()
    }
    fn()
    _this.end = new Date().getTime()
    _this.baseline += duration

    _this.nextTick = duration - (_this.end - _this.baseline)
    if (_this.nextTick < 0) {
      _this.nextTick = 0
    }

    if (_this.run !== undefined) {
      _this.timer = setTimeout(function () {
        _this.run()
      }, _this.nextTick)
    }
  }

  _this.stop = function () {
    clearTimeout(_this.timer);
    _this.run = undefined;
  }
}
